import { Module } from '@nestjs/common';
import { APP_FILTER, APP_GUARD } from '@nestjs/core';
import { ThrottlerGuard, ThrottlerModule } from '@nestjs/throttler';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { AllExceptionsFilter } from './common/filters/all-exceptions.filter';
import { PrismaModule } from './prisma/prisma.module';
import { ApplicationsModule } from './applications/applications.module';
import { ChatModule } from './chat/chat.module';
import { DemoCleanupModule } from './demo-cleanup/demo-cleanup.module';
import { KnowledgeModule } from './knowledge/knowledge.module';

@Module({
  imports: [
    // Generous relative to the main cart API's throttle (10/min) since a
    // live conversation can legitimately send several messages in quick
    // succession — this is abuse protection, not a conversational rate limit.
    ThrottlerModule.forRoot([{ ttl: 60_000, limit: 60 }]),
    PrismaModule,
    ApplicationsModule,
    ChatModule,
    DemoCleanupModule,
    KnowledgeModule,
  ],
  controllers: [AppController],
  providers: [
    AppService,
    { provide: APP_GUARD, useClass: ThrottlerGuard },
    { provide: APP_FILTER, useClass: AllExceptionsFilter },
  ],
})
export class AppModule {}
